import { useSiteConfigValue } from '@/hooks/useSiteConfigValue';

export const usePasswordPolicy = () => {
  const { value: simpleMode, loading } = useSiteConfigValue('password_policy_simple_mode', 'false');
  
  const isSimpleMode = simpleMode === 'true';
  
  const validatePassword = (password: string): { valid: boolean; message?: string } => {
    // Always check minimum requirements
    if (!password || password.length < 6) {
      return { valid: false, message: 'Password must be at least 6 characters long' };
    }
    
    if (password.length > 128) {
      return { valid: false, message: 'Password is too long' };
    }
    
    // Simple mode - just length check
    if (isSimpleMode) {
      return { valid: true };
    }
    
    // Complex mode - current requirements
    if (password.length < 8) {
      return { valid: false, message: 'Password must be at least 8 characters long' };
    }
    
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
      return { valid: false, message: 'Password must contain uppercase, lowercase, and number' };
    }
    
    return { valid: true };
  };
  
  const getPasswordRequirements = () => {
    if (isSimpleMode) {
      return [
        'At least 6 characters long',
        'Maximum 128 characters'
      ];
    }
    
    return [
      'At least 8 characters long',
      'Contains uppercase letter (A-Z)',
      'Contains lowercase letter (a-z)', 
      'Contains number (0-9)',
      'Maximum 128 characters'
    ];
  };
  
  return {
    validatePassword,
    getPasswordRequirements,
    isSimpleMode,
    loading
  };
};